import { render } from "./DanhSachHang.vue?vue&type=template&id=5180f514&scoped=true"
import script from "./DanhSachHang.vue?vue&type=script&lang=js"
export * from "./DanhSachHang.vue?vue&type=script&lang=js"

import "./DanhSachHang.vue?vue&type=style&index=0&id=5180f514&scoped=true&lang=css"

import exportComponent from "/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5180f514"]])

export default __exports__